import React, {useEffect} from 'react';
import AccountInfo from "../../components/revenue/common/AccountInfo";
import RevenueSummary from "../../components/revenue/common/RevenueSummary";
import RevenueDetail from "../../components/revenue/adsense/RevenueDetail";
import AdSetting from "../../components/revenue/adsense/AdSetting";
import RevenueTips from "../../components/revenue/RevenueTips";
import dateFormat from 'dateformat';
import {useDispatch, useSelector} from "react-redux";
import NotFoundPage from "../../components/NotFoundPage";
import {addPrefix} from "../../utils/UriUtil";
import {jsonResponseHandler} from "../../utils/FetchHelper";
import {setAdsenseInfo} from "../../actions/revenue";

const ManageAdsenseApp = () => {
  const dispatch = useDispatch();
  const revenue = useSelector(state => state.revenue);

  useEffect(() => {
    fetch(addPrefix("/manage/revenue/status/adsense.json"), {
      method: 'GET',
      credentials: 'include'
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        dispatch(setAdsenseInfo(data.data));
      })
      .catch(e => {
        console.log(e);
      });
  }, []);
  if (revenue.revenueVendors.includes('adsense')) {
    return (
      <div className="inner_article">
        <h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
        <h3 className="screen_out">수익</h3>
        <h4 className="tit_cont" style={{marginTop: 0}}>애드센스 관리</h4>
        <AccountInfo vendor="adsense"/>
        <RevenueSummary vendor="adsense"/>
        <RevenueDetail/>
        <h4 className="tit_cont">광고 설정</h4>
        <AdSetting/>
        <RevenueTips vendor="adsense"/>
      </div>
    )
  } else {
    return <NotFoundPage/>
  }
};

export default ManageAdsenseApp;